/**
 * Renders the Personnel Sync Mapping Form page
 */

import React from 'react';
import Box from '@mui/material/Box';

import BodyContainer from '@seccon/shared/ui/components/BodyContainer';
import ErrorBoundary from '@seccon/shared/ui/components/ErrorBoundary';
import filePondGlobalStyles from '@seccon/core/filepond/styles';
import '@seccon/core/filepond/plugins';

import MappingForm from './components/MappingForm';
import MappingHeader from './components/MappingHeader';

const styles = {
  bodyContainer: {
    alignItems: 'center'
  },
  formContainer: {
    flex: 1,
    width: '75%'
  },
  pageHeaderContainer: {
    width: '100%'
  }
};

const PersonnelMapping = () => (
  <BodyContainer sx={styles.bodyContainer}>
    {filePondGlobalStyles}
    <Box sx={styles.pageHeaderContainer}>
      <MappingHeader />
    </Box>
    <Box sx={styles.formContainer}>
      <ErrorBoundary>
        <MappingForm />
      </ErrorBoundary>
    </Box>
  </BodyContainer>
);

export default PersonnelMapping;
